import { Component, OnInit, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { NgForm, NgModel } from '@angular/forms';
import { AuthService } from '../services/authService';
import { User } from '../models/user';
import { UserRole } from '../models/userRoleModel';
import { Router } from '@angular/router';

@Component({
    selector: 'app-list-roles',
    templateUrl: './list-roles.component.html',
    styleUrl: './list-roles.component.scss',
    standalone: false
})
export class ListRolesComponent {
  user = new User('', false);
  userRoles: UserRole[] = [];
  response?: any;
  constructor(private http: HttpClient, private authService: AuthService, private router: Router) { }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();

    if (isLoggedIn) {
      this.getListOfRoles();
    }
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private getListOfRoles() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    this.http
      .get<any>('/api/Administration/list_roles', {
        headers: headers,
      })
      .pipe(catchError(this.handleError<any>('ngOnInit')))
      .subscribe({
        next: (result) => {
          this.userRoles = result.roles;
          // sort the roles by name
          this.userRoles = this.userRoles.sort((a, b) => a.name.localeCompare(b.name));
        },
        error: (error) => console.error(error),
      });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  public confirmDelete(uniqueId: string, isTrue: boolean) {
    var deleteSpan = 'deleteSpan_' + uniqueId;
    var confirmDeleteSpan = 'confirmDeleteSpan_' + uniqueId;
    if (isTrue) {
      document.getElementById(deleteSpan)?.classList.add("d-none");
      document.getElementById(confirmDeleteSpan)?.classList.remove("d-none");
    } else {
      document.getElementById(deleteSpan)?.classList.remove("d-none");
      document.getElementById(confirmDeleteSpan)?.classList.add("d-none");
    }
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  deleteRole(roleId: string) {
    if (!roleId) {
      return;
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': '*/*'
    });
    this.http.delete(`/api/Administration/deleterole`, {
      headers: headers,
      params: { roleId: roleId }
    }).pipe(catchError(this.handleError<any>('deleteRole')))
      .subscribe({
        next: (response) => {
          this.response = response;
          if (!response) {
            console.error("response is undefined");
          }
          else if (response?.success == false) {
            for (let errorMessage = 0; errorMessage < response.errorMessages.length; errorMessage++) {
              console.error(response.errorMessages[errorMessage]);
              window.alert(response.errorMessages);
            }
          } else {
            //success
            location.reload();
          }
        },
        error: (error) => {
          this.response = error;
          console.error(error.message);
        },
      });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
